import { signal } from '@preact/signals';

const env = signal({
  isDevEnv: false,
  CAPTCHA_TEST_TOKEN: '20000000-ffff-ffff-ffff-000000000002',
  CAPTCHA_TOKEN: '68f808fd-f88d-4667-9d6d-c9d66e13d81a',
  useCaptcha: false,
});

export const setupEnv = (values) => {
  env.value.isDevEnv = values['dev']
    ? values['dev'] === 'true'
    : process.env.PREACT_APP_DEV === 'true';
  env.value.CAPTCHA_TOKEN = values['captchaToken'] ?? env.value.CAPTCHA_TOKEN;
  env.value.useCaptcha = values['useCaptcha']
    ? values['useCaptcha'] === 'true'
    : process.env.PREACT_APP_USE_CAPTCHA === 'true';
};

export const useEnv = () => {
  return env.value;
};
